<template>
    <div class="container">
        <template v-if="!lock">
            <active-detail :activeLock="lock" @changeStatus="detailHide" />
        </template>
        <template v-if="lock">
            <turn-table @getStatus="changeTable" />
        </template>
    </div>
</template>

<script>
import Rem from './assets/rem/index';
import wxShare from '@utils/wxShare';
import turnTable from './components/turnTable';
import activeDetail from './components/activeDetail';
import api from './api/index';

export default {
    components: {
        turnTable,
        activeDetail,
    },
    data() {
        return {
            lock: true, //false显示活动页面
        };
    },
    mounted() {
        //console.log(this.$route.params);
        wxShare({
            title: '夏日文创礼包100%中奖~',
            desc: '最高享“0元定制”，现金红包和众多文创好礼等你来拿！',
            link: `${location.origin}/julydraw`,
            //img需要cdn
            imgUrl: 'http://wwj.jijiagames.com/web/act/20200722/share.jpg',
        });
        //分渠道+埋点
        switch (this.$route.params.source) {
            case 'tuiguang1':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push([
                        '_trackEvent',
                        '0元定制大礼包，100%中奖等你来拿',
                        '市场tuiguang1渠道扫码进入数量量 ',
                        window.location.href,
                    ]); // 百度埋点
                }
                break;
            case 'tuiguang2':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push([
                        '_trackEvent',
                        '0元定制大礼包，100%中奖等你来拿',
                        '市场tuiguang2渠道扫码进入数量量 ',
                        window.location.href,
                    ]);
                }
                break;
            default:
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push([
                        '_trackEvent',
                        '0元定制大礼包，100%中奖等你来拿',
                        '市场default渠道扫码进入数量量 ',
                        window.location.href,
                    ]);
                }
                break;
        }
    },
    methods: {
        changeTable(data) {
            if (!data) {
                this.lock = !this.lock;
            }
        },
        detailHide(data) {
            this.lock = !this.lock;
        },
    },
};
</script>

<style lang="scss" scoped>
body {
    margin: 0 auto;
}
@media screen and (min-width: 750px) {
    body {
        width: 750px;
    }
}
</style>
